import { Icon } from './Icon';
import { Link } from '../router/router';

/**
 * A compact header indicator for "something just went wrong" — the live half
 * of error reporting. The full, reviewable history lives on the Settings
 * screen this links to; this is only ever shown a recent count, never zero.
 */
export function ErrorBadge({ count }: { count: number }) {
  if (count <= 0) return null;

  return (
    <Link to="/settings" className="btn btn--sm btn--danger" title={`${count} recent stream error${count === 1 ? '' : 's'}`}>
      <Icon name="alertTriangle" size={14} />
      {count}
    </Link>
  );
}
